import React from "react";
import Content from "./content";
import AccountProvider from "./accountContext";
import { makeStyles } from "@material-ui/styles";
import SideBarNav from "./AccountNav/sideBarNav";
import { useMediaQuery } from "@mantine/hooks";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
  },
  desktopHeight: {
    height: `${theme.height - 64}px`,
  },
  mobileHeight: {
    height: `${theme.height - 64}px`,
  },
  account: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    overflow: "auto",
    overflowY: "auto",
  },
  footer: {
    margin: "0 auto",
    padding: "0.5rem 0",
    "& a": {
      fontSize: "0.9rem",
      color: theme.app.labelColor,
    },
  },
}));

const Account = ({ userManager }) => {
  const language = useSelector((state) => state.language);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const classes = useStyles();
  return (
    <AccountProvider>
      <div className={classes.container}>
        {!isMobile && <SideBarNav userManager={userManager} />}
        <div
          className={`${classes.account} ${
            isMobile ? classes.mobileHeight : classes.desktopHeight
          }`}
        >
          <main id="main-page-content-logged-in">
            <Content />
          </main>
          <footer className={classes.footer}>
            <a href="https://sirius.entryevent.se/ee-static/members/tillganglighetsredogorelse.html">
              {language.AccessibilityStatement}
            </a>
          </footer>
        </div>
      </div>
    </AccountProvider>
  );
};

export default Account;
